export default __webpack_public_path__ + "static/media/hero-2.ffd71849.jpeg";